import { createReducer } from '@reduxjs/toolkit';

import { RedliningManager, Loadable } from 'models';
import { makeThunkFromAPICall } from 'state';

export type RedliningState = {
    deleteRedliningResponse: Loadable<RedliningManager.API.ActionResponse>;
    addRedliningResponse: Loadable<RedliningManager.Redlining>;
    editRedliningResponse: Loadable<RedliningManager.Redlining>;
};

const initialState: RedliningState = {
    deleteRedliningResponse: {
        status: 'idle',
    },
    addRedliningResponse: {
        status: 'idle',
    },
    editRedliningResponse: {
        status: 'idle',
    },
};

export const [sendDeleteRedlining, setDeleteRedliningResponse] =
    makeThunkFromAPICall(RedliningManager.deleteRedlining, 'redlining/delete');

export const [addRedlining, setAddRedlining] = makeThunkFromAPICall(
    RedliningManager.addRedlining,
    'redlining/add',
);

export const [editRedlining, setEditRedlining] = makeThunkFromAPICall(
    RedliningManager.editRedlining,
    'redlining/edit',
);

export const redliningReducer = createReducer(initialState, (builder) => {
    builder.addCase(setDeleteRedliningResponse, (state, action) => {
        return {
            ...state,
            deleteRedliningResponse: {
                ...state.deleteRedliningResponse,
                ...action.payload.loadable,
            },
        };
    });

    builder.addCase(setAddRedlining, (state, action) => {
        return {
            ...state,
            addRedliningResponse: {
                ...state.addRedliningResponse,
                ...action.payload.loadable,
            },
        };
    });

    builder.addCase(setEditRedlining, (state, action) => {
        return {
            ...state,
            editRedliningResponse: {
                ...state.editRedliningResponse,
                ...action.payload.loadable,
            },
        };
    });
});

export const RedliningActions = {
    sendDeleteRedlining,
    addRedlining,
    editRedlining,
};

export default redliningReducer;
